import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'nav-items-group-container',
  templateUrl: './nav-items-group-container.component.html',
  styleUrls: ['./nav-items-group-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavItemsGroupContainerComponent {}
